import type { ParsedProductHints, ProductModel, ProductValidationResult } from './ProductTypes'
import { productNormalizer } from './ProductNormalizer'

/**
 * ProductValidator — structural integrity of fingerprints and product fields.
 */
export class ProductValidator {
  validateHints(hints: ParsedProductHints): ProductValidationResult {
    const errors: string[] = []
    const warnings: string[] = []

    if (!hints.normalized) errors.push('Descrição vazia após normalização')
    if (!hints.brand) warnings.push('Marca não identificada')
    if (!hints.category || hints.category === 'Geral') warnings.push('Categoria genérica')
    if (!hints.model && !hints.partNumber) errors.push('Modelo e Part Number ausentes')
    if (hints.partNumber && hints.partNumber.length < 4) warnings.push('Part Number curto')

    return { valid: errors.length === 0, errors, warnings }
  }

  validateProduct(product: ProductModel): ProductValidationResult {
    const errors: string[] = []
    const warnings: string[] = []

    if (!product.fingerprint) errors.push('Fingerprint obrigatório')
    if (!product.brand) warnings.push('Marca vazia')
    if (!product.category) errors.push('Categoria obrigatória')
    if (!product.model && !product.partNumber) errors.push('Modelo ou Part Number obrigatório')
    if (!Array.isArray(product.aliases)) errors.push('Aliases inválidos')
    if (product.aliases.some((a) => !a.trim())) warnings.push('Alias vazio detectado')

    const fp = productNormalizer.normalize(product.fingerprint)
    if (fp.includes(' ')) errors.push('Fingerprint não deve conter espaços')

    return { valid: errors.length === 0, errors, warnings }
  }

  assertUniqueFingerprints(products: ProductModel[]): ProductValidationResult {
    const seen = new Map<string, string>()
    const errors: string[] = []
    for (const product of products) {
      const key = productNormalizer.normalize(product.fingerprint)
      const existing = seen.get(key)
      if (existing && existing !== product.id) {
        errors.push(`Fingerprint duplicado: ${product.fingerprint}`)
      } else {
        seen.set(key, product.id)
      }
    }
    return { valid: errors.length === 0, errors, warnings: [] }
  }
}

export const productValidator = new ProductValidator()
